export enum ObjectKinds {
  Text = 1,
  Textarea = 2,
  Date = 3,
  Time = 4,
  CircreSelect = 5,
  Check = 6,
  Barcode = 7,
  NonDisplay = 8,
}
